import type { VisibilityOnPagesSettingsType } from './types';

export const visibilityOnPagesDefaultSettings: VisibilityOnPagesSettingsType = {
  visibilityOnPagesDisplayMode: 'allPages',
  visibilityOnPagesDisplayPages: [],
  visibilityOnPagesHideMode: 'none',
  visibilityOnPagesHidePages: []
};
